import(/* webpackMode: "eager" */ "/repo/apps/portal/src/app/global-error.tsx");
